"use client";
import React, { useEffect, useState } from "react";

export default function ModalPopup({ show }: { show: boolean }) {
  const [showModal, setShowModal] = useState(show);
  useEffect(() => {
    let timeout: NodeJS.Timeout;
    if (show) {
      setShowModal(true);
      timeout = setTimeout(() => {
        setShowModal(false);
      }, 3000);
    }
    return () => clearTimeout(timeout);
  }, [show]);

  const handleClose = () => {
    setShowModal(false);
  };
  return (
    <div
      className={`fixed top-0 left-0 w-full h-full flex items-center justify-center ${
        showModal ? "block" : "hidden"
      }`}
    >
      <div className="relative bg-gray-100 p-8 rounded-lg shadow-lg text-center">
        <button
          onClick={handleClose}
          className="absolute lg:right-[4px] md:right-[5px] right-[-4.1px] lg:top-[3px] md:top-[-5px] top-[-4.1px] z-[1] h-[10px] text-violet-500 hover:text-gray-700 focus:outline-none"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            fill="currentColor"
            className="bi bi-x"
            viewBox="0 0 16 16"
          >
            <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" />
          </svg>
        </button>
        <div className="flex items-center justify-center">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-16 w-16 text-violet-500 animate-checkmark"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-check-circle"
              viewBox="0 0 16 16"
            >
              <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
              <path d="M10.97 4.97a.235.235 0 0 0-.02.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05" />
            </svg>
          </svg>
        </div>
        <p className="text-violet-500 text-lg font-semibold mt-4">
          Thanks for submitting the form!
        </p>
      </div>
    </div>
  );
}
